import React from 'react';
import Helmet from 'react-helmet';

import Status from '../../../../components/global/Status';
import ContentWrap from '../../../../components/global/ContentWrap';
import { getAsset } from '../../../../util/assets';

const NotFound = () => (
  <div>
    <Helmet>
      <title>Not found &ndash; Waldo</title>
    </Helmet>

    <Status status={404}>
      <div className="wrapper-main">
        <div className="content-wrap content-wrap-gray">
          <ContentWrap size="sm">
            <div className="text-center">
              <h2 className="mb-3">Whoops!</h2>
              <img
                width="100px"
                src={getAsset('/waldo-icon-error.svg')}
                alt="Confused Waldo Icon"
                className="mb-3"
              />

              <p className="text-md">
                I can find <strong>anyone</strong> but I couldn&rsquo;t find the
                page you requested!
              </p>

              <p className="text-faded m-0">Not Found &ndash; Error 404</p>
            </div>
          </ContentWrap>
        </div>
      </div>
    </Status>
  </div>
);

export default NotFound;
